import { ComponentType, useEffect } from 'react';
import '../App.scss';
import '../editor.scss';
import '@syllepsis/plugin-basic/assets/style.css';
import useBiz from '@/context/useBiz';
import { Biz } from '@/typings/open.platform.forum_bff/namespaces/configure';
// const ForumLayout=()=>{

//   return (
//     <div>

//     </div>
//   )
// }
type Platform = 'developer' | 'merchant';
type Props = {
  platform: 'developer' | 'merchant';
};
const BizMap: Record<Platform, Exclude<Biz, 'ALL'>> = {
  developer: Biz.Open,
  merchant: Biz.Service,
};

const App = ({
  Component,
  props = { platform: 'developer' as Platform },
  ...pageProps
}: {
  Component: ComponentType;
  props?: Props;
}) => {
  // eslint-disable-next-line react/prop-types
  const { platform } = props;
  const state = useBiz();
  useEffect(() => {
    if (platform) {
      state.changeBiz(BizMap[platform]);
    }
  }, [platform, state.changeBiz]);

  useEffect(() => {
    window.Garfish?.channel.emit('main:im-close');
  }, []);

  return (
    <div
      className="h-full w-full bg-[#F9F9F9]"
      style={{
        minWidth: '1200px',
      }}>
      <Component {...pageProps} />
    </div>
  );
};

export default App;
